/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
// import DialogTitle from '@material-ui/core/DialogTitle';
import {
    object, string, shape, array, arrayOf, number, func,
} from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ReactHtmlParser from 'react-html-parser';
import { useLazyQuery } from '@apollo/react-hooks';
import ReactMarkdown from 'react-markdown';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import mbpLogger from 'mbp-logger';
import GraphqlProductImageUI from '../../GraphqlProductImageUI';
import YotpoProductReview from '../../YotpoProductReview';
import findProductPageByPartNumber from '../../../../../../gql/queries/findProductPageByPartNumber';
import GraphqlPortalLoader from '../../../../GraphqlCommonComponents/GraphqlPortalLoader';

const styles = (theme) => ({
    rootModal: {
        maxWidth: '800px',
    },
    quickViewModal: {
        padding: '0px 0px',
        marginTop: '-8px',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'pointer',
        '&:hover': {
            color: 'blue',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: 'none',
        },
    },
    quickViewText: {
        fontSize: '14px',
        textDecoration: 'underline',
    },
    productImageUI: {
        padding: '25px 10px 15px 10px',
        minWidth: '50%',
    },
    quickUpsellName: {
        color: theme.palette.cms?.pdpQuickView,
        fontFamily: theme.typography.fontFamily,
        padding: '40px 0px 0px 9px',
        width: '82%',
        float: 'left',
        fontWeight: '700',
        fontStyle: 'normal',
        fontSize: '18px',
    },
    quickUpsellPrice: {
        paddingLeft: '29%',
        color: theme.palette.cms?.pdpQuickView,
        fontFamily: theme.typography.fontFamily,
        fontWeight: '700',
        fontStyle: 'normal',
        fontSize: '18px',
    },
    cancelView: {
        borderWidth: '0px',
        left: '0px',
        top: '0px',
        width: '107px',
        height: '38px',
        background: 'inherit',
        backgroundColor: theme.palette.primary?.main,
        border: 'none',
        borderRadius: '20px',
        boxShadow: 'none',
        fontWeight: '700',
        fontStyle: 'normal',
        fontSize: '16px',
        color: theme.palette.globalBannerContainerBackground,
        '&:hover': {
            backgroundColor: theme.palette.cms?.icon,
        },
    },
    selectView: {
        borderWidth: '0px',
        left: '0px',
        top: '0px',
        width: '156px',
        height: '38px',
        background: 'inherit',
        backgroundColor: theme.palette.secondary?.main,
        border: 'none',
        borderRadius: '21px',
        fontWeight: '700',
        fontStyle: 'normal',
        fontSize: '16px',
        color: theme.palette.globalBannerContainerBackground,
        '&:hover': {
            backgroundColor: theme.palette.cms?.bgSelectColor,
        },
    },
    textArea: {
        width: '100%',
        height: '302px',
        resize: 'none',
        overflowY: 'scroll',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '0px',
        borderColor: theme.palette.cms?.skuAvailableToShipTextColor,
        marginTop: '10px',
    },
    rootTextArea: {
        padding: '34px 14px 0px 9px',
    },
    contentStyle: {
        padding: '2px 0px 2px 13px',
        fontWeight: '400',
        fontSize: '14px',
        color: theme.palette.text?.hint,
    },
    paperWidthSm: {
        maxWidth: '800px',
        maxHeight: 'fit-content',
    },
    dialogActions: {
        paddingBottom: '2%',
    },
    clickMore: {
        margin: '7% 0% 0% 90%',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    contentTitle: {
        fontWeight: '700',
        padding: '3px 0px 3px 3px',
    },
    longDescMarkDown: {
        margin: '-15px 0px 0px -11px',
    },
});

const GraphqlFoodQuickViewModal = ({
    classes,
    location,
    productUrl,
    quickViewData,
    product,
    brand,
    history,
    renderSkuPrice,
    selectedSku,
}) => {
    if (!quickViewData) {
        return null;
    }
    const domain = brand?.domain || null;

    const selectId = quickViewData.id || '';
    const selectedName = quickViewData.name || '';
    const partNumber = quickViewData.partNumber || '';
    const shortDescription = quickViewData.shortDescription || '';
    const image = quickViewData.image || '';
    const productContentSku = quickViewData.productSkus || [];
    const quickViewLongDesc = productContentSku?.[0]?.longDescription || quickViewData.longDescription || '';

    const [open, setOpen] = React.useState(false);

    const FIND_PDP_BY_PART = findProductPageByPartNumber(domain, selectId);
    const [loadPDP, { errorPDP, loading, data }] = useLazyQuery(FIND_PDP_BY_PART);

    if (loading) {
        return <GraphqlPortalLoader />;
    }
    if (data) {
        const productURL = data?.findProductPageByPartNumber?.product?.seo?.url || null;
        if (productURL) {
            history.push(productURL);
        }
    }
    if (errorPDP) { mbpLogger.logError({ message: `error prefetching PDP  ${errorPDP}` }); }

    const handleClickOpen = (event) => {
        event.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const selectQuickSKU = () => {
        setOpen(false);
        loadPDP();
    };

    return (
        <Grid>
            <button type="button" onClick={handleClickOpen} className={classes.quickViewModal}>
                <span className={classes.quickViewText}>Quick View</span>
            </button>
            <div className={classes.rootModal}>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{
                        paperWidthSm: classes.paperWidthSm,
                    }}
                >
                    <Grid container className={classes.modal}>
                        <Grid item sm={6} lg={6} className={classes.productImageUI}>
                            <GraphqlProductImageUI data={product} selectedSku={quickViewData} location={location} />
                        </Grid>
                        <Grid item sm={6} lg={6}>
                            <Grid item>
                                <Grid className={classes.quickUpsellName}>
                                    <span>{ReactHtmlParser(selectedName)}</span>
                                </Grid>
                                <Grid>
                                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container item sm={12} lg={12} className={classes.rootTextArea}>
                                <Grid item sm={6} lg={6} className={classes.quickUpsellYotpo}>
                                    <YotpoProductReview
                                        productUrl={productUrl}
                                        name={selectedName}
                                        partNumber={partNumber}
                                        shortDescription={shortDescription}
                                        image={image}
                                    />
                                </Grid>
                                <Grid item sm={6} lg={6} className={classes.quickUpsellPrice}>
                                    <span>{renderSkuPrice(selectedSku)}</span>
                                </Grid>
                                <div className={classes.textArea}>
                                    <div className={classes.contentTitle}><span>Contents</span></div>
                                    {quickViewLongDesc ? <ReactMarkdown source={quickViewLongDesc} escapeHtml={false} className={classes.longDescMarkDown} /> : null}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item sm={12} lg={12} className={classes.dialogActions}>
                            <DialogActions>
                                <Button onClick={handleClose} className={classes.cancelView}>
                                    Cancel
                                </Button>
                                <Button onClick={selectQuickSKU} className={classes.selectView}>
                                    Select
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                </Dialog>
            </div>
        </Grid>
    );
};

GraphqlFoodQuickViewModal.propTypes = {
    classes: object.isRequired,
    location: object.isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
        productContents: array.isRequired,
    }).isRequired,
    quickViewData: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    productUrl: string.isRequired,
    brand: object.isRequired,
    history: object.isRequired,
    renderSkuPrice: func.isRequired,
};
const enhance = compose(
    withStyles(styles),
    withRouter,
);

export default enhance(GraphqlFoodQuickViewModal);
